import type { User } from "@brookbush/database";

import useSWRImmutable from "swr/immutable";

interface UseRecentSignupsProps {
	count: number;
}

const useRecentSignups = ({ count }: UseRecentSignupsProps) => {
	const { data: recentSignups, ...rest } = useSWRImmutable<
		(User & { imageUrl: string })[]
	>(`/landing-pages/recent-signups?count=${count}`);

	return {
		recentSignups,
		...rest,
	};
};

export default useRecentSignups;
